import { useEffect } from 'react';

const StyleSettings = ({
	selectedStyle,
	setCSWidth,
	setCSLength,
	setCSHeight,
	setLLWidth,
	setLLLength,
	setLLHeight,
	setRLWidth,
	setRLLength,
	setRLHeight,
	setBLHeight,
	setBLLength,
	setBLWidth,
	setFLLength,
	setFLHeight,
	setFLWidth,
	setLeftLean,
	setRightLean,
	setCenterStorage,
	setDephCentralStorage,
}) => {
	useEffect(() => {
		if (selectedStyle === 'barn') {
			setCSWidth('18');
			setCSLength('20');
			setCSHeight('12');
			setLLWidth('12');
			setLLLength('20');
			setLLHeight('9');
			setRLWidth('12');
			setRLLength('20');
			setRLHeight('9');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('leanToOnly');
			setRightLean('leanToOnly');
			setCenterStorage('none');
		} else if (selectedStyle === 'carport') {
			setCSWidth('20');
			setCSLength('30');
			setCSHeight('7');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'tw') {
			setCSWidth('26');
			setCSLength('30');
			setCSHeight('10');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'wsd') {
			setCSWidth('32');
			setCSLength('20');
			setCSHeight('10');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'leanto') {
			setCSWidth('14');
			setCSLength('30');
			setCSHeight('10');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'slbarn') {
			setCSWidth('12');
			setCSLength('20');
			setCSHeight('10');
			setLLWidth('12');
			setLLLength('20');
			setLLHeight('7');
			setRLWidth('12');
			setRLLength('20');
			setRLHeight('7');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('leanToOnly');
			setRightLean('leanToOnly');
			setCenterStorage('none');
		} else if (selectedStyle === 'hexbarn') {
			setCSWidth('20');
			setCSLength('20');
			setCSHeight('8');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'garage') {
			setCSWidth('20');
			setCSLength('30');
			setCSHeight('8');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'rv') {
			setCSWidth('30');
			setCSLength('51');
			setCSHeight('16');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		} else if (selectedStyle === 'utility') {
			setCSWidth('20');
			setCSLength('36');
			setCSHeight('9');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setCenterStorage('back');
			setDephCentralStorage('15');
			setLeftLean('none');
			setRightLean('none');
		} else if (selectedStyle === 'garageleanto') {
			setCSWidth('20');
			setCSLength('35');
			setCSHeight('12');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('10');
			setRLLength('35');
			setRLHeight('10');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('leanToOnly');
			setCenterStorage('none');
		} else if (selectedStyle === 'openbarn') {
			setCSWidth('18');
			setCSLength('20');
			setCSHeight('12');
			setLLWidth('12');
			setLLLength('20');
			setLLHeight('9');
			setRLWidth('12');
			setRLLength('20');
			setRLHeight('9');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('leanToOnly');
			setRightLean('leanToOnly');
			setCenterStorage('none');
		} else if (selectedStyle === 'doubleleanto') {
			setCSWidth('15');
			setCSLength('25');
			setCSHeight('11');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('12');
			setRLLength('25');
			setRLHeight('9');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('leanToOnly');
			setCenterStorage('none');
		} else {
			// Reset to default values for other styles
			setCSWidth('20');
			setCSLength('30');
			setCSHeight('7');
			setLLWidth('');
			setLLLength('');
			setLLHeight('');
			setRLWidth('');
			setRLLength('');
			setRLHeight('');
			setFLHeight('');
			setFLLength('');
			setFLWidth('');
			setBLHeight('');
			setBLLength('');
			setBLWidth('');
			setLeftLean('none');
			setRightLean('none');
			setCenterStorage('none');
		}
	}, [selectedStyle]);

	return null;
};

export default StyleSettings;
